// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import I18NextHttpBackend from './i18nextBackend';

// Инициализация i18next
i18n
    .use(I18NextHttpBackend) // Использование нашего бэкенда для загрузки переводов из API
    .use(LanguageDetector) // Использование плагина для определения языка
    .use(initReactI18next)
    .init({
        fallbackLng: 'en', // Язык по умолчанию, если нужный язык отсутствует
        interpolation: {
            escapeValue: false, // React уже предотвращает XSS
        },
        supportedLngs: ['en', 'ru', 'sr', 'hr', 'es', 'pt', 'sl', 'fr', 'de'], // Добавлен список поддерживаемых языков
        detection: {
            // Настройки определения языка
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
            caches: ['localStorage', 'cookie'], // Сохраняет язык в localStorage или cookie
            lookupQuerystring: 'lng', // Параметр в URL для определения языка
            lookupCookie: 'i18next', // Имя cookie
            lookupLocalStorage: 'i18nextLng', // Ключ в localStorage
        },
    });

export default i18n;
